import React, { useEffect, useState, memo } from "react";
import { Link } from "react-router-dom";

import { Phone, MapPin, Building } from "lucide-react";

import { dadosImpressao } from "../../../../shared/util/dadosImpressao";
import "./InformacoesDaClinica.scss";

function InformacoesDaClinica({ sendRequest, clinica, auth }) {
  const [clinicaData, setClinicaData] = useState();

  useEffect(() => {
    const fetchClinica = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setClinicaData(responseData.clinica);
      } catch (err) {}
    };
    fetchClinica();
  }, [auth.token, clinica.clinica._id, sendRequest]);

  /* Mostra a UNIDADE onde se está a trabalhar, não a clínica.
   *
   * Quem lê este cartão está num sítio concreto e é a morada e o telefone
   * desse sítio que lhe interessam — para dar ao paciente, para conferir. Um
   * dentista em Assomada a ver a morada da Praia lê uma informação errada
   * sobre onde está.
   *
   * A clínica fica como recurso: nas clínicas de unidade única a sessão não
   * tem estabelecimento, e aí o cartão é exatamente o que sempre foi. */
  const unidade = auth?.estabelecimento;

  /* Pelo `dadosImpressao`, e não com a regra escrita aqui outra vez: a cópia
     local fazia o recurso campo a campo, e uma unidade com um só contacto
     mostrava o segundo contacto da sede. A regra dos blocos vive num sítio só. */
  const local = dadosImpressao(clinicaData, unidade) || {};
  const info = {
    nome: unidade?.nome || clinicaData?.nome,
    endereco: local.endereco,
    contacto: local.contacto,
    contacto2: local.contacto2,
  };

  return (
    <div className="dashboard__right__bottom">
      <span className="box-title">Informações da Clinica</span>
      {clinicaData && (
        <>
          <div className="clinic-info">
            <span className="medium-gray-text">
              <Building style={{ marginRight: 10 }} />
              {info.nome}
            </span>
            <span className="medium-gray-text">
              <MapPin style={{ marginRight: 10 }} />
              {info.endereco}
            </span>
            <span className="medium-gray-text">
              <Phone style={{ marginRight: 10 }} />
              {info.contacto ? info.contacto : ""}
              {info.contacto2 ? " / " + info.contacto2 : ""}
            </span>
          </div>
          <Link
            to={`/clinica/${clinica.clinica._id}`}
            className="link__dashboard"
          ></Link>
        </>
      )}
    </div>
  );
}

export default memo(InformacoesDaClinica);
